import React from 'react';
import Icon from '../Icon';
import { useTranslation } from 'react-i18next';

function NoSegmentationRow({ onSegmentationAdd, addSegmentationClassName }) {
  const { t } = useTranslation('SegmentationTable');
  return (
    <div
      className={`group flex items-center justify-center h-full w-full ${addSegmentationClassName}`}
      // onClick={onSegmentationAdd}
    >
      {/* <div className="text-primary-active flex items-center rounded-[4px] bg-white group-hover:cursor-pointer group-hover:bg-[#d9d9d9]">
         <div className="grid h-[28px] w-[28px] place-items-center">
          <Icon name="icon-add" />
        </div>
        <span className="text-[13px] font-bold text-black">{t('Add segmentation')}</span>
      </div> */}
      <span className="text-[12px] text-black font-bold">{t('No segmentations loaded')}</span>
    </div>
  );
}

export default NoSegmentationRow;
